<template>
 <div class="appointmentcontainer pb100">
  <banner/>
  <!-- <div class="crumbs-1">
    <div class="container">
      <a href="/show/index">首页</a>
      <span>&gt;</span>
      <a href="#">场馆预订</a>
    </div>
  </div> -->
  <crumbs />
  <div class="container">
      <type-screen modelType="venue" :menu-id="menuId" @typeObj="selectType"
      v-if="digitalPavilionId === undefined"
      />
    <ul class="ul-model3 clearfix">
      <li @click.stop="detaillink(item.id)" v-for="(item) in venuelist" :key="item.id">
        <a>
          <div class="imgbox">
            <img class="imgtop" :src="getImage(item.image)" alt="">
          </div>
          <h2 class="textover" v-if="item.typeValues != undefined && item.typeValues[0].name !== undefined" >{{item.typeValues[0].name}}</h2>
          <p class="textover type">{{item.name}}</p>
          <span>我要预订</span>
        </a>
      </li>
    </ul>
     <nodata v-show="nodataflag"/>
    <el-pagination
        @current-change="handleCurrentChange"
        :page-size="venueparams.limit"
        :pager-count="5"
        layout="prev, pager, next"
        :total="total"
        class="pagemodel1">
   </el-pagination>
  </div>
 </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import {getvenueList} from '@/api/venue/index'
import typeScreen from '@/components/typescreen/index'
import nodata from '@/components/nodata/index'
export default {
  name: 'venue',
  components: {
    typeScreen, crumbs, nodata, banner
  },
  data () {
    return {
      venueparams: {
        page: 1,
        limit: 12,
        moduleCode: '',
        types: '',
        areaType: '',
        type: '',
        codes: '',
        digitalPavilionId: ''
      },
      venuelist: [],
      total: 0,
      menuId: '',
      nodataflag: false,
      digitalPavilionId: ''
    }
  },
  meta: {
    showHeader: true
  },
  created () {
    this.menuId = this.$route.query.columnId
    this.venueparams.moduleCode = this.$route.query.columnId
    this.digitalPavilionId = this.$route.query.digitalPavilionId
    this.getVenulist()
  },
  watch: {
    $route (val) {
      if (val) {
        console.log(2)
        console.log(val)
      }
    }
  },
  methods: {
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    getVenulist () {
      this.venueparams.digitalPavilionId = this.digitalPavilionId === undefined ? null : this.digitalPavilionId
      getvenueList(this.venueparams).then(res => {
        console.log(res)
        this.venuelist = res.data.list.list
        this.total = res.data.list.total
        if (this.total === 0) {
          this.nodataflag = true
        } else {
          this.nodataflag = false
        }
      })
    },
    selectType (obj) {
      if (obj.codes !== undefined) {
        this.venueparams.codes = obj.codes.toString()
      }
      this.venueparams.types = obj.customTypeId
      this.venueparams.areaType = obj.areaType
      this.venueparams.type = obj.type
      this.getVenulist()
    },
    detaillink (id) {
      this.$router.push({path: '/venuedetail', query: {id, columnId: this.menuId}})
    },
    handleCurrentChange (val) {
      this.venueparams.page = val
      this.getVenulist()
    }
  },
  mounted () {
    // console.log(this.$route.query.nodeId)

    this.screenWidth = document.body.clientWidth
    // if (this.screenWidth < 768) {
    //   let conditionCArr = this.$refs.condition.children
    //   for (let i = 0; i < conditionCArr.length; i++) {
    //     let Carrli = conditionCArr[i].getElementsByTagName('li')
    //     let ulW = 0
    //     for (let j = 0; j < Carrli.length; j++) {
    //       ulW += Carrli[j].offsetWidth
    //     }
    //     conditionCArr[i].getElementsByTagName('ul')[0].style.width = ulW + 'px'
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.textover{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/venue/list.vue